// extracted by mini-css-extract-plugin
export default {"NirReader":"NirReader_NirReader__z6kBw"};